<template>
  <div class="search" v-if="conditionForm">
    <!-- table查询表单 -->
    <el-form ref="searchForm" :model="conditionForm" inline @submit.native.prevent>

      <!-- tab表格 -->
      <el-form-item v-if="conditionTab">
        <el-radio-group v-model="conditionTab.tabData" @change="conditionTab.tabClick">
          <el-radio-button :value="item" v-for="(item, index) in conditionTab.tabList" :key="index">{{ item }}
          </el-radio-button>
        </el-radio-group>

      </el-form-item>

      <template v-for="(item, index) in conditionCol" :key="index">
        <!-- radio类型 直接用tags数据 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='radio'">
          <el-radio-group class="row" v-model="conditionForm[item.prop]"
                          @change="(e)=>{if(item.searchChange)item.searchChange(e, index)}">
            <el-radio v-for="tag in item.tags" :key="tag.value" :label="tag.text" border
                      :value="tag.value" style="margin-right: 0">
              {{ tag.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- checkbox类型 直接用tags数据 -->
        <el-form-item :label="item.label" :prop="item.prop" style="width: 90%"
                      v-if="item.condition && item.condition=='checkbox'">
          <el-checkbox-group class="row" style="width: 100%;" v-model="conditionForm[item.prop]">
            <el-checkbox v-for="tag in item.tags" :key="tag.value" :label="tag.text" border
                         :value="tag.value" style="margin-right: 10px;margin-bottom: 10px"
                         @change="(e)=>{if(item.searchChange)item.searchChange(e, tag)}">
              {{ tag.text }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- input类型 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='like'">
          <el-input class="row" v-model.trim="conditionForm[item.prop]"
                    prefix-icon="Search" clearable :maxlength="item.max?item.max:'200'"
                    :placeholder="item.placeholder?item.placeholder:'请输入' + item.label"
                    :style="item.width?'width:'+item.width+'px':''"
                    @keyup.enter.native="searchClick"></el-input>
        </el-form-item>
        <!-- inputSelect类型 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='likeSelect'">
          <el-input class="row" v-model.trim="conditionForm[item.prop]"
                    prefix-icon="Search" clearable :maxlength="item.max?item.max:'200'"
                    :placeholder="item.placeholder?item.placeholder:'请输入' + item.label"
                    :style="item.width?'width:'+item.width+'px':'width:280px'"
                    @keyup.enter.native="searchClick">
            <template #prepend>
              <el-select v-model="conditionForm[item.extraProp]" placeholder="请选择" style="width: 100px">
                <el-option v-for="tag in item.sourceList" :key="tag.value" :label="tag.text"
                           :value="tag.value"></el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <!-- keywordFilter类型 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='keywordFilter'">
          <keyword-filter
            v-model="conditionForm[item.prop]"
            v-model:typeValue="conditionForm[item.extraProp]"
            :options="item.options"
            :clearable="item.clearable"
            :type-placeholder="item.typePlaceholder"
            :input-placeholder="item.inputPlaceholder"
            :width="item.width"
            :select-width="item.selectWidth"
            :select-min-width="item.selectMinWidth"
            :select-max-width="item.selectMaxWidth"
            :input-min-width="item.inputMinWidth"
            @type-change="(payload)=>{handleKeywordTypeChange(payload, item, index)}"
            @value-change="(payload)=>{handleKeywordValueChange(payload, item, index)}"
            @clear="(payload)=>{handleKeywordClear(payload, item, index)}"
            @enter="(payload)=>{handleKeywordEnter(payload, item, index)}"
          />
        </el-form-item>
        <!-- select类型 直接用tags数据 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='select'">
          <el-select class="row" v-model="conditionForm[item.prop]" clearable :multiple="item.multiple?true:false"
                     @change="(e)=>{if(item.searchChange)item.searchChange(e, index)}" filterable
                     :style="item.width?'width:'+item.width+'px':''" :disabled="item.disabled"
                     :placeholder="item.placeholder?item.placeholder:'请选择' + item.label">
            <el-option v-for="tag in item.tags" :key="tag.value" :label="tag.text" :value="tag.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- time类型 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='time'">
          <el-date-picker style="width: 340px;" v-model="conditionForm[item.prop]"
                          type="datetimerange" start-placeholder="请选择开始时间" end-placeholder="请选择结束时间"
                          :default-time="defaultTime" :shortcuts="getShortcuts(item)" clearable
                          @change="(e)=>{searchTimeChange(e,item, index)}"
                          @clear="(e)=>{clearChange(e,item, index)}"
                          @calendar-change="(e)=>{calendarChange(e, item, index)}"
                          @panel-change="(e)=>{updateChange(e,item, index)}"
                          @visible-change="(e)=>{visibleChange(e,item, index)}"
                          :disabled-date="(e)=>{return handleDisabledDate(e, item, index)}"
          ></el-date-picker>
        </el-form-item>
        <!-- yearrange -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='yearrange'">
          <el-date-picker style="width: 220px;" v-model="conditionForm[item.prop]" :disabled="item.disabled"
                          type="yearrange" start-placeholder="开始时间" end-placeholder="结束时间"
                          :default-time="defaultTime" :shortcuts="getShortcuts(item)" clearable
                          :disabled-date="(e)=>{return handleDisabledDate(e, item, index)}"
                          :editable="isDatePickerEditable(item)"
                          @change="(e)=>{searchTimeChange(e,item, index)}"
                          @clear="(e)=>{clearChange(e,item, index)}"
                          @calendar-change="(e)=>{calendarChange(e, item, index)}"
                          @visible-change="(e)=>{visibleChange(e,item, index)}"

          ></el-date-picker>
        </el-form-item>
        <!-- monthrange -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='monthrange'">
          <el-date-picker style="width: 220px;" v-model="conditionForm[item.prop]" :disabled="item.disabled"
                          type="monthrange" start-placeholder="开始时间" end-placeholder="结束时间"
                          :default-time="defaultTime" :shortcuts="item.getShortcuts ? item.getShortcuts() : []" clearable
                          :disabled-date="(e)=>{return handleDisabledDate(e, item, index)}"
                          :editable="isDatePickerEditable(item)"
                          @change="(e)=>{searchTimeChange(e,item, index)}"
                          @calendar-change="(e)=>{calendarChange(e, item, index)}"
                          @visible-change="(e)=>{visibleChange(e, item, index)}"
          ></el-date-picker>
        </el-form-item>
        <!-- dates类型 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='dates'">
          <el-date-picker style="width: 220px;" v-model="conditionForm[item.prop]" :disabled="item.disabled"
                          type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
                          :default-time="defaultTime" :shortcuts="getShortcuts(item)"
                          :clearable="false"
                          :disabled-date="(e)=>{return handleDisabledDate(e, item, index)}"
                          :editable="isDatePickerEditable(item)"
                          @change="(e)=>{searchTimeChange(e,item, index)}"
                          @clear="(e)=>{clearChange(e,item,index)}"

                          @calendar-change="(e)=>{calendarChange(e, item, index)}"
                          @visible-change="(e)=>{visibleChange(e, item, index)}"

          ></el-date-picker>
        </el-form-item>
        <!-- date类型 -->
        <el-form-item :label="item.label" :prop="item.prop"
                      v-if="item.condition && item.condition=='date'">
          <el-date-picker v-model="conditionForm[item.prop]"
                          type="date" placeholder="请选择日期" :style="item.width?'width:'+item.width+'px':''"
                          @change="(e)=>{searchTimeChange(e,item, index)}"></el-date-picker>
        </el-form-item>
      </template>

      <el-form-item v-if="searchBtn==false?false:true">
        <el-button class="form_btn" type="primary" @click="searchClick">搜索</el-button>
        <el-button class="form_btn" @click="clearClick">重置</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
import keywordFilter from '@/components/keywordFilter.vue'
export default {
  name: "formCondition", //查询条件组件
  components: {
    keywordFilter,
  },
  props: {
    conditionForm: {             //form条件数据
      type: null,
      default: null
    },
    conditionTab: {              //tab条件数据
      type: null,
      default: null
    },
    conditionCol: {              //条件列
      type: null,
      default: null
    },
    searchBtn: {                 //是否显示搜索按钮
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      defaultTime: [
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 2, 1, 23, 59, 59),
      ],
      firstTime: null,
    }
  },
  methods: {
    handleKeywordTypeChange(payload, item, index) {
      if (item.onKeywordTypeChange) {
        item.onKeywordTypeChange(payload, item, index, this.conditionForm)
      }
    },
    handleKeywordValueChange(payload, item, index) {
      if (item.onKeywordValueChange) {
        item.onKeywordValueChange(payload, item, index, this.conditionForm)
      }
    },
    handleKeywordClear(payload, item, index) {
      if (item.onKeywordClear) {
        return item.onKeywordClear(payload, item, index, this.conditionForm)
      }
    },
    handleKeywordEnter(payload, item, index) {
      if (item.onKeywordEnter) {
        return item.onKeywordEnter(payload, item, index, this.conditionForm)
      }
      this.searchClick()
    },

    /**
     * 获取最近查询选项
     */
    getShortcuts(item) {
      let shortcuts = [
        {
          text: '今日',
          value: () => {
            let start = new Date(this.$dayjs().format('YYYY-MM-DD') + ' 00:00:00');
            let end = new Date(this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59');
            return [start, end]
          },
        },
        {
          text: '昨日',
          value: () => {
            let start = new Date(this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD') + ' 00:00:00');
            let end = new Date(this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59:59');
            return [start, end]
          },
        },
        {
          text: '近7天',
          value: () => {
            let start = new Date(this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD') + ' 00:00:00');
            let end = new Date(this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59');
            return [start, end]
          },
        },
        {
          text: '近30天',
          value: () => {
            let start = new Date(this.$dayjs().subtract(30, 'day').format('YYYY-MM-DD') + ' 00:00:00');
            let end = new Date(this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59');
            return [start, end]
          },
        },
        {
          text: '上一周',
          value: () => {
            let start = new Date(this.$dayjs().add(-1, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD') + ' 00:00:00');
            let end = new Date(this.$dayjs().add(-1, 'week').endOf('week').add(1, 'day').format('YYYY-MM-DD') + ' 23:59:59');
            return [start, end]
          }
        },
        {
          text: '上一月',
          value: () => {
            let start = new Date(this.$dayjs().add(-1, 'month').startOf('month').format('YYYY-MM-DD') + ' 00:00:00');
            let end = new Date(this.$dayjs().add(-1, 'month').endOf('month').format('YYYY-MM-DD') + ' 23:59:59');
            return [start, end]
          }
        },
      ];
      //自定义快捷条件,暂时不需要加
      if (item.shortcuts && item.shortcuts.includes('lastWeek')) {
        // shortcuts.push({
        //     text: '上一周',
        //     value: () => {
        //         let start = new Date(this.$dayjs().add(-1, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD') + ' 00:00:00');
        //         let end = new Date(this.$dayjs().add(-1, 'week').endOf('week').add(1, 'day').format('YYYY-MM-DD') + ' 23:59:59');
        //         return [start, end]
        //     }
        // })

      }
      if(item.shortcuts && item.shortcuts.includes('disable')) {
        return []
      }
      return shortcuts;
    },
    handleDisabledDate(time, item, index) {
      if (typeof item.disabledDateFun === 'function') {
        return item.disabledDateFun(time, item, index)
      }
      return this.disabledDateFun(time, item, index)
    },
    isDatePickerEditable(item) {
      return !this.getDisabledDateConfig(item).firstSelectRange
    },
    getDisabledDateConfig(item = {}) {
      const config = item.disabledDateConfig || {}
      const hasCustomConfig = !!item.disabledDateConfig
      const hasOwn = (key) => Object.prototype.hasOwnProperty.call(config, key)
      const firstSelectRange = hasOwn('firstSelectRange')
        ? this.normalizeDateLimit(config.firstSelectRange, 'month')
        : hasOwn('rangeLimit')
          ? this.normalizeDateLimit(config.rangeLimit, 'month')
          : this.normalizeDateLimit(item.isDateLimit, 'month')

      return {
        minDate: config.minDate || config.beforeDateLimit || item.beforeDateLimit || null,
        maxDate: config.maxDate || config.afterDateLimit || item.afterDateLimit || null,
        firstSelectRange,
        vipRule: hasCustomConfig
          ? this.normalizeVipRule(config.vipRule)
          : this.normalizeVipRule(true),
      }
    },
    normalizeVipRule(vipRule) {
      if (vipRule === false || vipRule === null) {
        return { enabled: false }
      }
      if (typeof vipRule === 'undefined') {
        return { enabled: false }
      }

      const config = vipRule === true ? {} : vipRule
      const hasOwn = (key) => Object.prototype.hasOwnProperty.call(config, key)

      return {
        enabled: true,
        nonVipLookback: hasOwn('nonVipLookback')
          ? this.normalizeDateLimit(config.nonVipLookback, 'day')
          : this.normalizeDateLimit(60, 'day'),
        nonVipRange: hasOwn('nonVipRange')
          ? this.normalizeDateLimit(config.nonVipRange, 'month')
          : this.normalizeDateLimit(2, 'month'),
        vipRange: hasOwn('vipRange')
          ? this.normalizeDateLimit(config.vipRange, 'month')
          : this.normalizeDateLimit(3, 'month'),
      }
    },
    normalizeDateLimit(limit, defaultUnit = 'day') {
      if (limit === false || limit === null || typeof limit === 'undefined') {
        return null
      }

      if (typeof limit === 'number') {
        return limit > 0 ? { value: limit, unit: defaultUnit } : null
      }

      if (typeof limit === 'string') {
        const value = Number(limit)
        return value > 0 ? { value, unit: defaultUnit } : null
      }

      if (typeof limit === 'object') {
        const rawValue = typeof limit.value !== 'undefined'
          ? limit.value
          : typeof limit.amount !== 'undefined'
            ? limit.amount
            : limit.limit
        const value = Number(rawValue)
        if (!(value > 0)) {
          return null
        }
        return {
          value,
          unit: limit.unit || defaultUnit,
        }
      }

      return null
    },
    applyDateLimit(baseDate, limit, method) {
      return this.$dayjs(baseDate)[method](limit.value, limit.unit || 'day')
    },
    /**
     * 日期面板显示隐藏
     */
    visibleChange(time, item, index) {
      this.firstTime = null
      this.disabledDateFun(time, item, index);
    },

    /**
     * 第一个日期按下
     */
    calendarChange(e, item, index) {
      this.firstTime = Array.isArray(e) && e.length > 0 ? e[0] : null
    },
    /**
     * 时间组件清空操作
     */
    clearChange(time, item, index){
      this.firstTime = null
      this.disabledDateFun(time, item, index);
    },
    updateChange(time,item, index){
    },
    /**
     * 设置选中日期
     */

    disabledDateFun(time, item, index) {
      const date = this.$dayjs(time)
      if (!time || !date.isValid()) {
        return false
      }

      const config = this.getDisabledDateConfig(item)
      const activeStartTime = this.firstTime
      if (config.minDate && date.isBefore(this.$dayjs(config.minDate), 'day')) {
        return true;
      }

      if (config.maxDate && date.isAfter(this.$dayjs(config.maxDate), 'day')) {
        return true;
      }
      //是否为会员
      if (config.firstSelectRange && activeStartTime) {
        const start = this.applyDateLimit(activeStartTime, config.firstSelectRange, 'subtract')
        const end = this.applyDateLimit(activeStartTime, config.firstSelectRange, 'add')
        if (!date.isBetween(start, end, 'day', '[]')) {
          return true;
        }
      }
      const isVip = !!this.$store.state.shopInfo.vipTime;
      if (!config.vipRule.enabled) {
        return false
      }
      if (!isVip) {
        // 非会员只能选择当前时间前60天以内的日期
        if (config.vipRule.nonVipLookback) {
          const minDate = this.applyDateLimit(this.$dayjs(), config.vipRule.nonVipLookback, 'subtract')
          if (date.isBefore(minDate, 'day')) {
            return true;
          }
        }

        // 首次点击后，非会员限制在所选日期前后指定范围内
        if (activeStartTime && config.vipRule.nonVipRange) {
          const start = this.applyDateLimit(activeStartTime, config.vipRule.nonVipRange, 'subtract')
          const end = this.applyDateLimit(activeStartTime, config.vipRule.nonVipRange, 'add')
          if (!date.isBetween(start, end, 'day', '[]')) {
            return true;
          }
        }
      }
      // 会员版本根据当前选中时间查询前后指定范围
      if (isVip && activeStartTime && config.vipRule.vipRange) {
        const start = this.applyDateLimit(activeStartTime, config.vipRule.vipRange, 'subtract')
        const end = this.applyDateLimit(activeStartTime, config.vipRule.vipRange, 'add')
        if (!date.isBetween(start, end, 'day', '[]')) {
          return true;
        }
      }



      return false; // 所有条件都合法 => 不禁用
    },
    /**
     * 搜索时间点击
     */
    searchTimeChange(time,item, index) {
      if (item.searchTimeChange) {
        const result = item.searchTimeChange(time,item, index);
        this.firstTime = null;
        return result
      }
      this.searchClick();
      this.firstTime = null;
      this.disabledDateFun(time, item, index);
    },

    /**
     * 查询点击
     */
    searchClick: function () {
      this.$emit('searchClick', '');
    },

    /**
     * 清空点击
     */
    clearClick() {
      this.$refs.searchForm.resetFields();
      this.$emit('searchClick', '');
    },

  },
  mounted() {

  }
}
</script>

<style scoped>
/*去掉select悬浮不出现小手问题*/
:deep(.el-select__wrapper) {
  cursor: pointer !important;
}

/*去掉select选中出现黑框问题*/
:deep(.el-select__wrapper:focus) {
  outline: none !important;
}

.search {
  position: relative;
  width: 100%;
  margin-top: 14px;
}

.row {
  width: 160px;
}

:deep(.el-form--inline .el-form-item) {
  margin-right: 20px;
}

:deep(.el-image__wrapper ) {
  top: 2px;
}

:deep(.el-image__error) {
  line-height: 14px;
  font-size: 12px;
}

.form_btn {
  padding-left: 10px;
  padding-right: 10px;
}

</style>
